import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmailsService } from '../services/emails.service';

@Component({
  selector: 'app-bulkemail',
  templateUrl: './bulkemail.component.html',
  styleUrls: ['./bulkemail.component.scss']
})
export class BulkemailComponent implements OnInit {

  modalRef: BsModalRef;
  Email:FormGroup;
  previousEmails:any;

  constructor(
    private modalService: BsModalService,
    private formBuilder:FormBuilder,
    private emailService:EmailsService
  ) { }

  ngOnInit(): void {
    this.Email = this.formBuilder.group({
      subject:'',
      body:''
    })
    this.getAllEmails()
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  cancel(): void {
    this.modalRef.hide();
  }

  sendEmail(){
    let data = {
      "subject":this.Email.get('subject').value,
      "body":this.Email.get('body').value
      }
      this.emailService.sendEmails(data).then((res:any)=>{
        if(res.success){
          this.Email.get('subject').setValue('');
          this.Email.get('body').setValue('');
          this.getAllEmails()
          this.modalRef.hide();
        }
      })
  }

  getAllEmails(){
    this.emailService.getAllEmails()
    .then((res:any)=>{
      this.previousEmails = res.emails
      console.log(this.previousEmails)
    })
  }

  viewEmail(subject, body){
    this.Email.get('subject').setValue(subject)
    this.Email.get('body').setValue(body)
  }

}
